//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import species from '~/graphql/queries/species.gql';

export default {
  props: {
    speciesUuid: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    species: {},
    loaded: false,
  }),
  computed: {
    months() {
      return [
        {
          title: 'Jan',
          active: this.species.properties.months.january,
        },
        {
          title: 'Feb',
          active: this.species.properties.months.february,
        },
        {
          title: 'Mrt',
          active: this.species.properties.months.march,
        },
        {
          title: 'Apr',
          active: this.species.properties.months.april,
        },
        {
          title: 'Mei',
          active: this.species.properties.months.may,
        },
        {
          title: 'Jun',
          active: this.species.properties.months.june,
        },
        {
          title: 'Jul',
          active: this.species.properties.months.july,
        },
        {
          title: 'Aug',
          active: this.species.properties.months.august,
        },
        {
          title: 'Sept',
          active: this.species.properties.months.september,
        },
        {
          title: 'Okt',
          active: this.species.properties.months.october,
        },
        {
          title: 'Nov',
          active: this.species.properties.months.november,
        },
        {
          title: 'Dec',
          active: this.species.properties.months.december,
        },
      ];
    },
  },
  mounted() {
    this.$apollo.query({
      query: species,
      variables: {
        uuid: this.speciesUuid,
      },
    }).then((data) => {
      this.species = JSON.parse(JSON.stringify(data.data.species));
      this.species.properties = JSON.parse(this.species.properties);
      this.loaded = true;
    });
  },
};
